<template>
  <div class="border-b border-gray-200 mb-6 overflow-x-auto">
    <nav class="flex space-x-6 min-w-max" aria-label="Tabs">
      <!-- Tab: Dashboard -->
      <button
        type="button"
        :class="[
          activeTab === 'dashboard'
            ? 'border-orange-500 text-orange-600 font-bold'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 font-medium',
          'py-3.5 px-1 border-b-2 text-sm flex items-center gap-2 transition-colors cursor-pointer'
        ]"
        @click="$emit('change-tab', 'dashboard')"
      >
        <i class="fa fa-chart-line text-sm" :class="activeTab === 'dashboard' ? 'text-orange-500' : 'text-gray-400'" />
        <span>Dashboard & Estadísticas</span>
      </button>

      <!-- Tab: Personal -->
      <button
        type="button"
        :class="[
          activeTab === 'employees'
            ? 'border-orange-500 text-orange-600 font-bold'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 font-medium',
          'py-3.5 px-1 border-b-2 text-sm flex items-center gap-2 transition-colors cursor-pointer'
        ]"
        @click="$emit('change-tab', 'employees')"
      >
        <i class="fa fa-users text-sm" :class="activeTab === 'employees' ? 'text-orange-500' : 'text-gray-400'" />
        <span>Personal</span>
        <span 
          v-if="totalEmployees > 0"
          class="px-2 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-700"
        >
          {{ totalEmployees }}
        </span>
      </button>

      <!-- Tab: Turnos & Destajo -->
      <button
        type="button"
        :class="[
          activeTab === 'shifts'
            ? 'border-orange-500 text-orange-600 font-bold'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 font-medium',
          'py-3.5 px-1 border-b-2 text-sm flex items-center gap-2 transition-colors cursor-pointer'
        ]"
        @click="$emit('change-tab', 'shifts')"
      >
        <i class="fa fa-calendar-check text-sm" :class="activeTab === 'shifts' ? 'text-orange-500' : 'text-gray-400'" />
        <span>Turnos & Destajo</span>
        <span 
          v-if="pendingShiftsCount > 0"
          class="px-2 py-0.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800"
        >
          {{ pendingShiftsCount }} pendientes
        </span>
      </button>

      <!-- Tab: Liquidación y Pagos -->
      <button
        type="button"
        :class="[
          activeTab === 'payments'
            ? 'border-orange-500 text-orange-600 font-bold'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 font-medium',
          'py-3.5 px-1 border-b-2 text-sm flex items-center gap-2 transition-colors cursor-pointer'
        ]"
        @click="$emit('change-tab', 'payments')"
      >
        <i class="fa fa-receipt text-sm" :class="activeTab === 'payments' ? 'text-orange-500' : 'text-gray-400'" />
        <span>Liquidación y Pagos</span>
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'PaysheetTabs',

  props: {
    activeTab: {
      type: String,
      default: 'dashboard',
    },
    totalEmployees: {
      type: Number,
      default: 0,
    },
    pendingShiftsCount: {
      type: Number,
      default: 0,
    },
  },

  emits: ['change-tab'],
}
</script>
